import { IconComponent } from './icon.component';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        /**
         * Components / Directives/ Pipes
         */
        IconComponent,
    ],
    imports: [],
    exports: [ IconComponent ]
})
export class IconComponentModule {
}
